<template>
    <h1 class="headline">Loading...</h1>
</template>

<script>
    export default {
        created () {
            const deviceId = this.$route.query.id_device,
                checkSum = this.$route.query.check;
        },
    }
</script>
